"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var InputBase_1 = __importDefault(require("@mui/material/InputBase"));
// Used for Select
var InputBase = (0, material_1.styled)(InputBase_1.default)(function (_a) {
    var _b;
    var theme = _a.theme, props = __rest(_a, ["theme"]);
    return ({
        lineHeight: '20px',
        borderRadius: 6,
        input: { display: 'none' },
        ' .MuiSelect-select ': { lineHeight: 'inherit' },
        '&.MuiInputBase-sizeSmall': {
            ' .MuiSelect-outlined': {
                minHeight: 0,
                padding: theme.spacing(0.625, 2),
            },
        },
        '&.MuiInputBase-colorPrimary': { color: theme.palette.riverstone },
        border: "1px solid ".concat((props === null || props === void 0 ? void 0 : props.color) && ((_b = theme.palette[props.color || 'primary']) === null || _b === void 0 ? void 0 : _b.light)),
        '&.Mui-error': {
            borderColor: theme.palette.error.main,
            color: theme.palette.error.dark,
        },
        '.MuiFormHelperText-root': {
            margin: 0,
            marginTop: theme.spacing(0.25),
            paddingLeft: theme.spacing(1.5),
            textAlign: 'left',
            fontSize: 12,
            lineHeight: '14px',
        },
    });
});
exports.default = InputBase;
